import React from 'react';
import SvgComponent from 'components/Form/SvgComponent';
import './AnnouncementBanner.scss';
import { Announcement } from '@redux/modules/api/actions';

type Props = {
  announcement: Announcement,
  currentSubsectionKey?: string
}

type State = {
  disabled: boolean;
}

export class AnnouncementBanner extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      disabled: false,
    };

    this.dismissBanner = this.dismissBanner.bind(this);
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.currentSubsectionKey !== this.props.currentSubsectionKey
      && (this.props.currentSubsectionKey === "IDENTIFICATION_INTRO"
        || this.props.currentSubsectionKey === "REVIEW_AND_SUBMIT_SUBMIT")) {
      this.setState({ disabled: false, });
    }
  }

  dismissBanner() {
    this.setState({ disabled: true, });
  }

  render() {
    return (
      <>{this.state.disabled !== true && (
        <div className="usa-alert usa-alert-warning announcement-banner">
          <div className="announcement-banner__wrapper">
            <div className="announcement-banner__text-wrapper">
              <h4 className="usa-alert-text announcement-banner__text">
                {this.props.announcement.title}
              </h4>
              <p className="usa-alert-text announcement-banner__text">
                {this.props.announcement.content}
              </p>
            </div>
            <div className={'toggle-icon xmark'}>
              <button
                type="button"
                className="toggle-icon xmark"
                onClick={this.dismissBanner}
              >
                <SvgComponent className={'toggle-icon xmark'} src={'/img/xmark.svg'} />
              </button>
            </div>
          </div>
        </div>
      )}</>
    );
  }
}

AnnouncementBanner.defaultProps = {
  currentSubsectionKey: '',
  announcement: {}
};

export default AnnouncementBanner;
